import React from 'react'
import { Link } from 'react-router-dom'

import { Icon } from '@fourthwall/components'

import * as S from './NewPostLinks.styled'
import type { Props } from './types'

export const NewPostLinks = ({ links, getLinkHref }: Props) => (
  <S.Container>
    {links.map((link) => (
      <S.Link as={Link} to={getLinkHref(link)}>
        <Icon component={link.icon} height={16} />
      </S.Link>
    ))}
  </S.Container>
)
